<div [style.transform]="transform | safeStyle">
  @if (hotspot.InitialPovDegrees !== null) {
    <div class="radar" [style.transform]="rotate | safeStyle">
    </div>
  }
  <div class="hotspot-circle" [ngClass]="{pulse: pulse}">
    <icon [name]="hotspot.IconName"></icon>
  </div>
</div>